//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";
import "@/styles/flatpickr.css"

export default {
  name: "Home",
  components: {
    // flatPickr,
  },
  data: function() {
    return {
      listctgr: [],
      newsData: [[]],
      slide: 1,
      date: null,
      agenda: [],
      dateConfig: {
        inline: true,
        disable: [{
            from: "2000-01-01",
            to: "2099-05-01"
        },],
        enable: [],
        minDate: "today",
        maxDate: new Date(new Date().setMonth(new Date().getMonth() + 9)),
        showMonths: parseInt(this.$q.screen.width / 350),
        // altFormat: "F j, Y",
        // altInput: true,
        disableMobile: "true",
        locale: {
          weekdays: {
            shorthand: ["S", "M", "T", "W", "T", "F", "S"],
            longhand: [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ],
          },
        },
      },
    };
  },
  async mounted() {
    this.$http.get("/category_info", {}).then((result) => {
      this.listctgr = result.data;
    });

    await this.$http.get("/upcoming/agenda", {}).then((result) => {

      this.agenda = result.data;
      this.agenda.forEach(e => {
        e.active = false
        console.log(e);
        this.dateConfig.enable.push(e.date)
      });
    });

    this.$http.get("/big_news_update", {}).then(result=>{
      if(this.$q.screen.width > 1000){
        this.newsData[0].push(result.data.Jsondata[0])
        this.newsData[0].push(result.data.Jsondata[1])
        this.newsData[0].push(result.data.Jsondata[2])
      }
      else if(this.$q.screen.width > 700){
        this.newsData = [[],[]]
        this.newsData[0].push(result.data.Jsondata[0])
        this.newsData[0].push(result.data.Jsondata[1])
        this.newsData[1].push(result.data.Jsondata[2])
      }
      else{
        this.newsData = [[],[],[]]
        this.newsData[0].push(result.data.Jsondata[0])
        this.newsData[1].push(result.data.Jsondata[1])
        this.newsData[2].push(result.data.Jsondata[2])
      }
    })  


    this.$forceUpdate();
  },
  methods: {
    doSomethingOnChange(date, str, inst) {
      // var contents = "";
      // if (date.length) {
      //   for (i = 0; i < eventDates[str].length; i++) {
      //     contents +=
      //       '<div class="event"><div class="date">' +
      //       flatpickr.formatDate(date[0], "l J F") +
      //       '</div><div class="location">' +
      //       eventDates[str][i] +
      //       "</div></div>";
      //   }
      // }
      // $("#calendar .calendar-events").html(contents);
      
      this.agenda.forEach(element => {
        var a=new Date(str)
        var b=new Date(element.date)
        if(a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()) {
          element.active = true
        }
        else
          element.active =false
      });
    },
  },
  computed: {
    winWidth() {
      return this.$q.screen.width;
    },
    winHeight() {
      return this.$q.screen.height;
    },
  },
};
